import { getFromStorage } from "../components/utils";


export function getToken() {
  const usuario = getFromStorage('contarsEmpresa');
  return usuario ? usuario.token_us : '';
}

export function getID() {
  const usuario = getFromStorage('contarsEmpresa');
  return usuario ? usuario.id_usuario : '';
}

export function Usuario() {
  const usuario = getFromStorage('contarsEmpresa');
  return usuario || '';
}
